export class DataColumn {
    value: string;
    show?: boolean = true;
    width: number;
}
